import { render, staticRenderFns } from "./InvoiceInfoForm.vue?vue&type=template&id=b70def4c&"
import script from "./InvoiceInfoForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports